// This file manages exports from the base atom, molecule, or organism.
// Use named rather than default exports.
import dynamic from 'next/dynamic';
import { EditableComponent } from '@adobe/aem-react-editable-components';

export const FindReservationOverlay = dynamic(() =>
  import('./FindReservationOverlay').then(mod => mod.FindReservationOverlay)
);

export const FindReservationOverlayConfig = {
  emptyLabel: 'findReservation',
  isEmpty: false,
  resourceType: `mi-aem-account/components/content/findreservation`,
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const FindReservationOverlayEditable = (props: any) => {
  return (
    <EditableComponent config={FindReservationOverlayConfig} {...props}>
      <FindReservationOverlay {...props} />
    </EditableComponent>
  );
};
